import React, { useState } from "react";
import hiv_styles from './HIV.module.css';
import PageLayout from "../components/PageLayout";
import styled from 'styled-components';
import NextButton from "../components/NextButton";
import QuestionBox from "../components/QuestionBox";
import Select, { components } from 'react-select';


const FlexBox = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: 40px;
    @media (max-width: 768px) {
        flex-direction: column;
    }
`;

export const DropdownIndicator = props => {
    return (
      <components.DropdownIndicator {...props} >
        <span style={{ fontSize: '11px', lineHeight: '4px', marginLeft: '-6px'}}>&#9660;</span>
      </components.DropdownIndicator>
    );
  };

  export const customStyles = {
    control: (provided) => ({
      ...provided,
      borderRadius: '5px', // Adjust border radius as needed
      borderColor: '#93B3FC', // Border color of the select box
      minHeight: '20px',
        height: '30px',
        boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.1)',
        width: '250px'
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      color: '#93B3FC',
      height: '5px',
      width: '5px',
       // Color of the dropdown indicator triangle
    }),
  };

  
const Hiv = (props) => {
    const questions = [
        "What is your gut feeling about how likely you are to get infected with HIV?",
        "I worry about getting infected with HIV:",
        "Picturing myself getting HIV is something I find:",
        "I am sure I will NOT get infected with HIV:",
        "I feel vulnerable to HIV infection:",
        "There is a chance, no matter how small, I could get HIV:",
        "I think my chances of getting infected with HIV are:",
        "Getting HIV is something I have:"

        ]
    const [answers, setAnswers] = useState([0, 0, 0, 0, 0, 0, 0, 0]);
    // console.log(answers)

    React.useEffect(() => {
        const filteredAnswers = answers.filter(value => value === 0);
        if (filteredAnswers.length == 0) {
            let data = {
                THRIVE10: answers[0],
                THRIVE11: answers[1],
                THRIVE12: answers[2],
                THRIVE13: answers[3],
                THRIVE14: answers[4],
                THRIVE15: answers[5],
                THRIVE16: answers[6],
                THRIVE17: answers[7]
            }
            props.setHIVInfoData(data);
            props.setNextButton(true);
            props.onAllAnswered(false);
        } else {
            props.setNextButton(false);
        }
    }, [answers]);

    const handleAnswerChange = (index, value) => {
        const newAnswers = [...answers];
        newAnswers[index] = parseInt(value);
        setAnswers(newAnswers);
    }

    const question8Options = [
        { value: 1, label: "Never thought about " },
        { value: 2, label: "Rarely thought about" },
        { value: 3, label: "Thought about some of the time" },
        { value: 4, label: "Thought about often" },
        { value: 98, label: "I choose not to answer " }
    ]

    const question1optioins = [
        { value: 1, label: "Extremely unlikely" },
        { value: 2, label: "Very unlikely" },
        { value: 3, label: "Somewhat likely" },
        { value: 4, label: "Very likely" },
        { value: 5, label: "Extremely likely" },
        { value: 98, label: "I choose not to answer " }
    ]

    const question2optioins = [
        { value: 1, label: "None of the time" },
        { value: 2, label: "Rarely" },
        { value: 3, label: "Some of the time" },
        { value: 4, label: "A moderate amount of time" },
        { value: 5, label: "A lot of the time" },
        { value: 98, label: "I choose not to answer " }
    ]

    const question3options = [
        { value: 1, label: "Very hard to do" },
        { value: 2, label: "Hard to do" },
        { value: 3, label: "Easy to do" },
        { value: 4, label: "Very easy to do" },
        { value: 98, label: "I choose not to answer " }
    ]

    const question456options = [
        { value: 1, label: "Strongly disagree" },
        { value: 2, label: "Disagree" },
        { value: 3, label: "Somewhat disagree" },
        { value: 4, label: "Somewhat agree" },
        { value: 5, label: "Agree" },
        { value: 6, label: "Strongly agree" },
        { value: 98, label: "I choose not to answer " }
    ]

    const question7options = [
        { value: 1, label: "Zero" },
        { value: 2, label: "Almost zero" },
        { value: 3, label: "Small" },
        { value: 4, label: "Moderate" },
        { value: 5, label: "Large" },
        { value: 6, label: "Very Large" },
        { value: 98, label: "I choose not to answer " }
    ]

    const options = {
        0: question1optioins,
        1: question2optioins,
        2: question3options,
        3: question456options,
        4: question456options,
        5: question456options,
        6: question7options,
        7: question8Options
    }

    return (<>
            <div className={hiv_styles.webContainer}>
            <h2 className={hiv_styles.mainTitle}>HIV</h2>

                {questions.map((question, index) => (
                    <>
                        <FlexBox>
                            <QuestionBox color={props.showUnanswered && (answers[index] == 0) ? 'red' : 'black'} marginLeft='-40px' width='50%' question={question} index={index+1}></QuestionBox>
                            <div>
                                <Select
                                    options={options[index]}
                                    components={{ DropdownIndicator }}
                                    styles={customStyles}
                                    placeholder="Select an option"
                                    onChange={(op) => handleAnswerChange(index, op.value)}
                                    isSearchable={false}
                                    />
                            </div>
                            <div>

                            </div>
                        </FlexBox>
                        
                    </>

                    ))}
            </div>
    </>
    );
}

export default Hiv;